import React, { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { X, Clock, AlertTriangle } from "lucide-react";

const rowStyle = { borderColor: "rgba(15,18,38,0.06)" };

/* The last few sign-ins for one account — any account with a login. */
export const LoginActivityModal = ({ who, onClose }) => {
  const [d, setD] = useState(null);
  const [err, setErr] = useState("");

  useEffect(() => {
    api.get(`/admin/login-activity/${who.id}`)
      .then(({ data }) => setD(data))
      .catch((e) => setErr(formatApiError(e.response?.data?.detail) || "Could not load the activity"));
  }, [who.id]);

  const s = d?.last_30_days;
  const shared = s && (s.distinct_ips > 3 || s.distinct_devices > 2);

  return (
    <div className="fixed inset-0 z-[200] flex items-center justify-center p-4"
      style={{ background: "rgba(15,18,38,0.55)", backdropFilter: "blur(8px)" }}
      onClick={onClose} data-testid="activity-modal">
      <div className="glass p-6 w-full max-w-lg relative" onClick={(e) => e.stopPropagation()}
        style={{ background: "rgba(255,255,255,0.98)" }}>
        <button type="button" onClick={onClose} className="absolute top-3 right-3 org-icon-btn" data-testid="activity-close">
          <X size={15} />
        </button>
        <div className="kpi-label">Sign-in activity</div>
        <h3 className="font-display text-xl font-semibold tracking-tight">{who.label}</h3>
        <div className="text-[12px] text-ink-3">{who.email}</div>

        {err && <div className="chip chip-amber mt-4 inline-block" data-testid="activity-error">{err}</div>}
        {!d && !err && <div className="text-sm text-ink-2 mt-4">Loading…</div>}

        {d && (
          <>
            <div className="grid grid-cols-3 gap-2 mt-4">
              {[["Sign-ins", s.sign_ins], ["Different IPs", s.distinct_ips], ["Devices", s.distinct_devices]].map(([k, v]) => (
                <div key={k} className="glass p-3" style={{ background: "rgba(15,18,38,0.03)" }}>
                  <div className="kpi-label">{k} · 30d</div>
                  <div className="font-display text-lg font-semibold">{v}</div>
                </div>
              ))}
            </div>
            {shared && (
              <div className="chip chip-amber mt-3 inline-flex items-center gap-2" data-testid="activity-shared-warning">
                <AlertTriangle size={12} /> Several IPs and devices this month — worth a look
              </div>
            )}
            <div className="mt-4 max-h-[280px] overflow-y-auto">
              {!d.events.length && <div className="text-sm text-ink-2" data-testid="activity-empty">No sign-ins recorded yet.</div>}
              {d.events.map((e) => (
                <div key={e.id} className="flex items-center gap-3 py-2 border-t" style={rowStyle} data-testid={`activity-row-${e.id}`}>
                  <Clock size={13} className="text-ink-3 shrink-0" />
                  <div className="min-w-0 flex-1">
                    <div className="text-[13px] font-medium">{String(e.at).slice(0, 16).replace("T", " ")} · {e.device || "unknown device"}</div>
                    <div className="text-[11.5px] text-ink-3">{e.ip || "no ip"} · signed in with {e.method}</div>
                  </div>
                </div>
              ))}
            </div>
            <p className="text-[11px] text-ink-3 mt-3">{d.note}</p>
          </>
        )}
      </div>
    </div>
  );
};

export default LoginActivityModal;
